function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import crypto, { isCryptoKey } from './webcrypto.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import { encodeBase64, decodeBase64 } from './base64url.js';
import formatPEM from '../lib/format_pem.js';
import { JOSENotSupported } from '../util/errors.js';
import { types } from './is_key_like.js';
var genericExport = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(keyType, keyFormat, key) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (isCryptoKey(key)) {
            _context.next = 2;
            break;
          }
          throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types))));
        case 2:
          if (key.extractable) {
            _context.next = 4;
            break;
          }
          throw new TypeError('CryptoKey is not extractable');
        case 4:
          if (!(key.type !== keyType)) {
            _context.next = 6;
            break;
          }
          throw new TypeError("key is not a ".concat(keyType, " key"));
        case 6:
          _context.t0 = formatPEM;
          _context.t1 = encodeBase64;
          _context.t2 = Uint8Array;
          _context.next = 11;
          return crypto.subtle.exportKey(keyFormat, key);
        case 11:
          _context.t3 = _context.sent;
          _context.t4 = new _context.t2(_context.t3);
          _context.t5 = (0, _context.t1)(_context.t4);
          _context.t6 = "".concat(keyType.toUpperCase(), " KEY");
          return _context.abrupt("return", (0, _context.t0)(_context.t5, _context.t6));
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function genericExport(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var toSPKI = function toSPKI(key) {
  return genericExport('public', 'spki', key);
};
export var toPKCS8 = function toPKCS8(key) {
  return genericExport('private', 'pkcs8', key);
};
var _findOid = function findOid(keyData, oid) {
  var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (from === 0) {
    oid.unshift(oid.length);
    oid.unshift(0x06);
  }
  var i = keyData.indexOf(oid[0], from);
  if (i === -1) return false;
  var sub = keyData.subarray(i, i + oid.length);
  if (sub.length !== oid.length) return false;
  return sub.every(function (value, index) {
    return value === oid[index];
  }) || _findOid(keyData, oid, i + 1);
};
var getNamedCurve = function getNamedCurve(keyData) {
  switch (true) {
    case _findOid(keyData, [0x2a, 0x86, 0x48, 0xce, 0x3d, 0x03, 0x01, 0x07]):
      return 'P-256';
    case _findOid(keyData, [0x2b, 0x81, 0x04, 0x00, 0x22]):
      return 'P-384';
    case _findOid(keyData, [0x2b, 0x81, 0x04, 0x00, 0x23]):
      return 'P-521';
    case _findOid(keyData, [0x2b, 0x65, 0x6e]):
      return 'X25519';
    case _findOid(keyData, [0x2b, 0x65, 0x6f]):
      return 'X448';
    case _findOid(keyData, [0x2b, 0x65, 0x70]):
      return 'Ed25519';
    case _findOid(keyData, [0x2b, 0x65, 0x71]):
      return 'Ed448';
    default:
      throw new JOSENotSupported('Invalid or unsupported EC Key Curve or OKP Key Sub Type');
  }
};
var genericImport = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(replace, keyFormat, pem, alg, options) {
    var _options$extractable;
    var algorithm, keyUsages, keyData, isPublic, namedCurve;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          keyData = new Uint8Array(atob(pem.replace(replace, '')).split('').map(function (c) {
            return c.charCodeAt(0);
          }));
          isPublic = keyFormat === 'spki';
          _context2.t0 = alg;
          _context2.next = _context2.t0 === 'PS256' ? 5 : _context2.t0 === 'PS384' ? 5 : _context2.t0 === 'PS512' ? 5 : _context2.t0 === 'RS256' ? 8 : _context2.t0 === 'RS384' ? 8 : _context2.t0 === 'RS512' ? 8 : _context2.t0 === 'RSA-OAEP' ? 11 : _context2.t0 === 'RSA-OAEP-256' ? 11 : _context2.t0 === 'RSA-OAEP-384' ? 11 : _context2.t0 === 'RSA-OAEP-512' ? 11 : _context2.t0 === 'ES256' ? 14 : _context2.t0 === 'ES384' ? 17 : _context2.t0 === 'ES512' ? 20 : _context2.t0 === 'ECDH-ES' ? 23 : _context2.t0 === 'ECDH-ES+A128KW' ? 23 : _context2.t0 === 'ECDH-ES+A192KW' ? 23 : _context2.t0 === 'ECDH-ES+A256KW' ? 23 : _context2.t0 === 'Ed25519' ? 27 : _context2.t0 === 'EdDSA' ? 30 : 33;
          break;
        case 5:
          algorithm = {
            name: 'RSA-PSS',
            hash: "SHA-".concat(alg.slice(-3))
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.abrupt("break", 34);
        case 8:
          algorithm = {
            name: 'RSASSA-PKCS1-v1_5',
            hash: "SHA-".concat(alg.slice(-3))
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.abrupt("break", 34);
        case 11:
          algorithm = {
            name: 'RSA-OAEP',
            hash: "SHA-".concat(parseInt(alg.slice(-3), 10) || 1)
          };
          keyUsages = isPublic ? ['encrypt', 'wrapKey'] : ['decrypt', 'unwrapKey'];
          return _context2.abrupt("break", 34);
        case 14:
          algorithm = {
            name: 'ECDSA',
            namedCurve: 'P-256'
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.abrupt("break", 34);
        case 17:
          algorithm = {
            name: 'ECDSA',
            namedCurve: 'P-384'
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.abrupt("break", 34);
        case 20:
          algorithm = {
            name: 'ECDSA',
            namedCurve: 'P-521'
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.abrupt("break", 34);
        case 23:
          namedCurve = getNamedCurve(keyData);
          algorithm = namedCurve.startsWith('P-') ? {
            name: 'ECDH',
            namedCurve: namedCurve
          } : {
            name: namedCurve
          };
          keyUsages = isPublic ? [] : ['deriveBits'];
          return _context2.abrupt("break", 34);
        case 27:
          algorithm = {
            name: 'Ed25519'
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.abrupt("break", 34);
        case 30:
          algorithm = {
            name: getNamedCurve(keyData)
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.abrupt("break", 34);
        case 33:
          throw new JOSENotSupported('Invalid or unsupported "alg" (Algorithm) value');
        case 34:
          return _context2.abrupt("return", crypto.subtle.importKey(keyFormat, keyData, algorithm, (_options$extractable = options === null || options === void 0 ? void 0 : options.extractable) !== null && _options$extractable !== void 0 ? _options$extractable : false, keyUsages));
        case 35:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function genericImport(_x4, _x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();
export var fromPKCS8 = function fromPKCS8(pem, alg, options) {
  return genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, 'pkcs8', pem, alg, options);
};
export var fromSPKI = function fromSPKI(pem, alg, options) {
  return genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, 'spki', pem, alg, options);
};
function getElement(seq) {
  var result = [];
  var next = 0;
  while (next < seq.length) {
    var nextPart = parseElement(seq.subarray(next));
    result.push(nextPart);
    next += nextPart.byteLength;
  }
  return result;
}
function parseElement(bytes) {
  var position = 0;
  var tag = bytes[0] & 0x1f;
  position++;
  if (tag === 0x1f) {
    tag = 0;
    while (bytes[position] >= 0x80) {
      tag = tag * 128 + bytes[position] - 0x80;
      position++;
    }
    tag = tag * 128 + bytes[position] - 0x80;
    position++;
  }
  var length = 0;
  if (bytes[position] < 0x80) {
    length = bytes[position];
    position++;
  } else if (length === 0x80) {
    length = 0;
    while (bytes[position + length] !== 0 || bytes[position + length + 1] !== 0) {
      if (length > bytes.byteLength) {
        throw new TypeError('invalid indefinite form length');
      }
      length++;
    }
    var _byteLength = position + length + 2;
    return {
      byteLength: _byteLength,
      contents: bytes.subarray(position, position + length),
      raw: bytes.subarray(0, _byteLength)
    };
  } else {
    var numberOfDigits = bytes[position] & 0x7f;
    position++;
    length = 0;
    for (var i = 0; i < numberOfDigits; i++) {
      length = length * 256 + bytes[position];
      position++;
    }
  }
  var byteLength = position + length;
  return {
    byteLength: byteLength,
    contents: bytes.subarray(position, byteLength),
    raw: bytes.subarray(0, byteLength)
  };
}
function spkiFromX509(buf) {
  var tbsCertificate = getElement(getElement(parseElement(buf).contents)[0].contents);
  return encodeBase64(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function getSPKI(x509) {
  var pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, '');
  var raw = decodeBase64(pem);
  return formatPEM(spkiFromX509(raw), 'PUBLIC KEY');
}
export var fromX509 = function fromX509(pem, alg, options) {
  var spki;
  try {
    spki = getSPKI(pem);
  } catch (cause) {
    throw new TypeError('Failed to parse the X.509 certificate', {
      cause: cause
    });
  }
  return fromSPKI(spki, alg, options);
};